import * as yup from "yup";
/**
 * Advertisement Settings Validation Schema
 */
export const adValidationSchema = yup.object().shape({
    enabled: yup.boolean().required("是否啟用廣告為必填"),
    shuffle_mode: yup.boolean().required("隨機播放模式為必填"),
    media: yup
        .array()
        .of(
            yup.object().shape({
                key: yup.string().required(),
                name: yup.string().required("廣告名稱為必填"),
                type: yup.string().oneOf(["image", "video"]).required(),
                duration: yup
                    .number()
                    .nullable()
                    .transform((value, originalValue) => {
                        // Handle string to number conversion from form inputs
                        if (originalValue === "" || originalValue === null || originalValue === undefined) {
                            return null;
                        }
                        const parsed = Number(originalValue);
                        return isNaN(parsed) ? null : parsed;
                    })
                    .when("type", {
                        is: "image",
                        then: (schema) => schema.required("圖片需要設定顯示時間").min(1, "顯示時間至少1秒"),
                        otherwise: (schema) => schema.nullable(),
                    }),
                url: yup.string().test("url-or-file", "請上傳媒體檔案或提供媒體連結", function (value) {
                    if (!value || value.trim() === "") {
                        return true;
                    }
                    try {
                        new URL(value);
                        return true;
                    } catch {
                        return this.createError({ message: "請輸入有效的 URL 格式" });
                    }
                }),
                updated_at: yup.string().required(),
                is_permanent: yup.boolean().required(),
                start_at: yup
                    .mixed()
                    .nullable()
                    .when("is_permanent", {
                        is: false,
                        then: (schema) => schema.required("需要設定廣告開始時間"),
                        otherwise: (schema) => schema.nullable(),
                    }),
                end_at: yup
                    .mixed()
                    .nullable()
                    .when("is_permanent", {
                        is: false,
                        then: (schema) => schema.required("需要設定廣告結束時間"),
                        otherwise: (schema) => schema.nullable(),
                    }),
            })
        )
        .max(10, "最多只能設定10組廣告"),
});
